import { setCookie } from 'cookies-next'
import { distinctIdCookieKey } from '../../cookie-keys'
import type { OptionsType } from 'cookies-next/lib/types'

export function _setDistinctIdCookieOnServer(distinctId: string, options: OptionsType) {
  setCookie(distinctIdCookieKey, distinctId, options)
}
